<ngb-alert *ngIf="errorMessage" type="danger" (close)="errorMessage = null">{{
  errorMessage
  }}</ngb-alert>
<ng-container>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <ng-container [ngSwitch]="modalType">
        <ng-container *ngSwitchCase="'warningCancellation'">
          <span> مخالفة قيد رقم #{{ franchiseNo }} </span>
        </ng-container>
        <ng-container *ngSwitchCase="'restrictionStop'">
          <span> إيقاف قيد رقم #{{ franchiseNo }} </span>
        </ng-container>
        <ng-container *ngSwitchCase="'restrictionCancellation'">
          <span> إلغاء قيد رقم #{{ franchiseNo }} </span>
        </ng-container>
      </ng-container>
    </h4>
    <span (click)="close()">
      <i class="fa-solid fa-xmark cursor-pointer"></i>
    </span>
  </div>
  <form [formGroup]="form_Group" (ngSubmit)="save()">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12" *ngIf="modalType == 'warningCancellation'">
          <div class="form-group">
            <label for="reason">
              سبب المخالفة <span class="required"> * </span>
            </label>
            <input [qcId]="'reason_text'" formControlName="reasonDesc" type="text" id="reason" class="form-control"
              placeholder="اكتب سبب المخالفة" />

            <div [qcId]="'div-error2'" class="text-danger mt-2">
              <div *ngIf="controlHasError('required', 'reasonDesc', form_Group)">
                {{ "AdminFranchise.reason_Required" | translate }}
              </div>
              <div *ngIf="controlHasError('maxlength', 'reasonDesc', form_Group)">
                {{ "AdminFranchise.reasonDesc_MaxLength" | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12" *ngIf="
            modalType == 'restrictionCancellation' ||
            modalType == 'restrictionStop'
          ">
          <div class="form-group">
            <div class="row">
              <div class="col-md-10">
                <label for="cancel">
                  <ng-continer *ngIf="modalType == 'restrictionCancellation'">
                    سبب الإلغاء
                  </ng-continer>
                  <ng-continer *ngIf="modalType == 'restrictionStop'">
                    سبب الإيقاف
                  </ng-continer>
                  <span class="required"> * </span>
                </label>
              </div>
              <div class="col-md-2" *ngIf="modalType != 'restrictionCancellation'">
                <div class="d-flex align-items-center">
                  <input type="checkbox" (change)="showreasontext($event)" />
                  <span class="mx-2 text-admin-primary">اخري</span>
                </div>
              </div>
            </div>

            <ng-select [qcId]="'reason-select'" *ngIf="!showReasonText" formControlName="reasonId" placeholder="اختر..">
              <ng-option *ngFor="let reason of reasons" [value]="reason.id">
                {{ reason.description }}
              </ng-option>
            </ng-select>

            <div [qcId]="'div-error1'" class="text-danger mt-2">
              <div *ngIf="controlHasError('required', 'reasonId', form_Group)">
                {{ "AdminFranchise.reason_Required" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="
            (modalType == 'restrictionCancellation' ||
              modalType == 'restrictionStop') &&
            showReasonText
          ">
          <div class="form-group">
            <textarea [qcId]="'reason_text'" formControlName="reasonDesc" class="form-control" id="reason"
              [placeholder]="
              modalType == 'restrictionCancellation'
                  ? 'اكتب سبب الإلغاء '
                  : ' اكتب سبب الإيقاف'
              "></textarea>

            <div [qcId]="'div-error2'" class="text-danger mt-2">
              <div *ngIf="controlHasError('required', 'reasonDesc', form_Group)">
                {{ "AdminFranchise.reason_Required" | translate }}
              </div>
              <div *ngIf="
                  controlHasError('minlength', 'reasonDesc', form_Group) ||
                  controlHasError('maxlength', 'reasonDesc', form_Group)
                ">
                {{ "AdminFranchise.reasonDesc_Length" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label *ngIf="modalType != 'warningCancellation'" for="comment">
              الملاحظات (اختياري)</label>
            <label *ngIf="modalType == 'warningCancellation'" for="comment">
              الملاحظات <span class="required"> * </span>
            </label>
            <textarea [qcId]="'note_text'" formControlName="notes" class="form-control" id="comment"
              placeholder="اكتب تعليقك هنا.."></textarea>

            <div [qcId]="'div-error3'" class="text-danger mt-2">
              <div *ngIf="
                  this.modalType != 'warningCancellation' &&
                  (controlHasError('minlength', 'notes', form_Group) ||
                    controlHasError('maxlength', 'notes', form_Group))
                ">
                {{ "AdminFranchise.Notes_Length" | translate }}
              </div>
              <div *ngIf="
                  this.modalType == 'warningCancellation' &&
                  controlHasError('required', 'notes', form_Group)
                ">
                {{ "AdminFranchise.notes_Required" | translate }}
              </div>
              <div *ngIf="
                  this.modalType == 'warningCancellation' &&
                  controlHasError('maxlength', 'notes', form_Group)
                ">
                {{ "AdminFranchise.Notes_MaxLength" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="reason">
              هل لديك مرفقات تود أن تشاركها معنا؟
              <span class="required"> * </span></label>
            <div class="input-group mb-3">
              <div class="custom-file file-upload">
                <file-upload class="w-100" [isRequired]="true" name="file" #reasonfileUpload
                  (onSuccess)="fileUploadSuccess($event)" (onError)="fileUploadError($event)" [noOfFiles]="1"
                  [objectId]="objectId" [attachmentTypeId]="reasonAttachmentTypeId" [objectTypeId]="objectTypeId"
                  [extensions]="extensions" [isAdmin]="'true'">
                </file-upload>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="close()">
        رجوع
      </button>
      <button type="submit" [disabled]="!(form_Group.valid && reasonfileUpload.isFormValid())" class="btn btn-danger">
        <ng-continer *ngIf="modalType == 'warningCancellation'">
          مخالفة قيد الامتياز
        </ng-continer>
        <ng-continer *ngIf="modalType == 'restrictionCancellation'">
          إلغاء قيد الامتياز
        </ng-continer>
        <ng-continer *ngIf="modalType == 'restrictionStop'">
          إيقاف قيد الامتياز
        </ng-continer>
      </button>
    </div>
  </form>
</ng-container>